<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        
        <h5 class="mb-0 text-primary"><i class="fas fa-book text-primary"></i> Book List</h5>
      </div>
      <hr />
      <div class="row g-3">
         <div class="col-md-3">
            <label class="form-label">
              Class<sup><span class="text-danger font-12">*</span></sup> :
            </label>
            <div class="dropdown">
              <button class="form-select form-select-sm rounded dropdown-toggle w-100 dropdown-a"  type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ clsList.find(c => c._id === Obj.clsID)?.name || "" }}
              </button>
              <ul class="dropdown-menu w-100 scrollable-menu" >
                <li v-for="(item, index) in uniqueClsList" :key="index">
                  <a class="dropdown-item" href="#" @click.prevent="Obj.clsID = item._id"  @change="listData()">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        <div class="col-md-3">
          <label class="form-label">Section<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select class="form-select form-select-sm rounded cursor-pointer" role="button" v-model="Obj.sectionID" @change="listData()">
            <option selected=""></option>
            <option v-for="(item, index) in secList" :key="index" :value="item._id">
              {{ item.Name }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Student<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select v-model="Obj.studentID" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option v-for="(item, index) in
              List1" :key="index" :value="item._id"> {{ item.firstName }}  {{ item.lastName }}  </option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Status<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <select v-model="Obj.status" class="form-select form-select-sm rounded cursor-pointer" role="button">
            <option selected=""></option>
            <option value="Paid">Paid</option>
            <option value="Not Paid">Not Paid</option>
            <option value="Free">Free</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Note<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <input type="text" class="form-control form-control-sm" v-model="Obj.Note" />
        </div>
        <div class="col-md-9 mt-5 text-end ">
          <button class="btn btn-sm btn-darknavy me-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <button type="button" class="btn btn-sm btn-soft-dark" @click="reset()"><i class="fa fa-times-circle  me-1"></i> Cancel</button>
        </div>
        <ul v-if="errors.length" class="text-danger ps-3">
          <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12 table-responsive mt-2">
           <DataTable :columns="cols" :rows="filteredRows" :pageSize="10"   :actions="{  edit: handleEdit, delete: handleDelete }" />
        </div>
      </div>
    </div>
  </div>
  <DelPopup :name="Students.find(stu => stu._id == delObj.studentID)?.firstName || ''" @delRecord="delRecord" @closeModal="delObj.studentID = ''">
  </DelPopup>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import DelPopup from "@/components/Common/DelPopup.vue";
import DataTable from "@/components/Common/DataTable.vue";
import { isRequired, validateForm } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted,computed} from 'vue'
 import { schoolStore } from '@/utils/schoolStore';
const { clsList,uniqueClsList, secList} = schoolStore();
  const  Obj = ref({clsID: "", sectionID: "", studentID: "", Note: "", status: "", })
  const List1= ref([])
   const Students= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   delObj = ref({})
    const   errors= ref({})
    const   errors1= ref({})
const cols=ref([
  { label: 'S.No', key: 'Sno' },
  { label: 'Class', key: 'cls' },
  { label: 'Student', key: 'student' },
   { label: 'Mobile No.', key: 'Phone' },
  { label: 'Note', key: 'Note' },
  { label: 'Status', key: 'status', type: 'budget' }
]);
const handleEdit = async (row) => {
    Obj.value = { ...row }
       await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}/`)
          .then(async(res) => { 
            List1.value = res.data 
            const res1 = await api.get(`/students/${ Obj.value.studentID}`);
            Obj.value.studentID =res1.data.student._id
          });
}
const handleDelete = (row) => {
  delObj.value = { ...row };
}
const rows=ref([])
const filteredRows = computed(() => {
  return rows.value.filter(row => {
    const matchClass = Obj.value.clsID ? row.clsID === Obj.value.clsID : true;
    const matchSection = Obj.value.sectionID ? row.sectionID === Obj.value.sectionID : true;
    const matchStudent = Obj.value.studentID ? row.studentID === Obj.value.studentID : true;
    return matchClass && matchSection && matchStudent;
  });
}); 
const loadStudents= async() => {
  const res = await api.get(`/students/search`);
  Students.value = res.data;
}
const listData= async()=> {
      const fields = {
        clsID: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], }
      };
      errors1.value = validateForm(fields);
      if (Object.keys(errors1.value).length === 0) {
        await api .get(`/students/clssection/${Obj.value.clsID}/${Obj.value.sectionID}`)
        .then((res) => { List1.value = res.data });
      }
    }
    const save = async() => {
      const fields = {
        Class: { value: Obj.value.clsID, validators: [isRequired], },
        Section: { value: Obj.value.sectionID, validators: [isRequired], },
        Student: { value: Obj.value.studentID, validators: [isRequired], },
        Status: { value: Obj.value.status, validators: [isRequired], },
        Note: { value: Obj.value.Note, validators: [isRequired], },
      };
      errors.value = validateForm(fields);
      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/booklist${url}`, Obj.value)
          .then((response) => {
            reset();
            msgObj.value = { msg: `BookList ${msg} Successfuly`, role: "success", show: true, };
            loadData();
            console.log(response);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
    const reset= async()=> {
      Obj.value = { clsID: "", sectionID: "", studentID: "", Note: "", status: "", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
  const progress = ref(0)
    const loadData= async()=> {
    let direction = 1
     let progressInterval = setInterval(() => {
       progress.value += direction
       if (progress.value >= 100) {
         progress.value = 0 
       }
     }, 100)
      await api.get('/booklist/all') .then((response) => { rows.value = response.data.map((item, i) => ({ ...item, Sno: i + 1,
        cls: `${clsList.value.find(c => c._id === item.clsID)?.name || ''}${clsList.value.find(c => c._id === item.clsID)?.name ? (secList.value.find(s => s._id === item.sectionID)?.Name ? ' (' + secList.value.find(s => s._id === item.sectionID)?.Name + ')' : '') : ''}` 
      }));
       });
        rows.value.forEach(async(row)=>{
           await api .get(`/students/${row.studentID}`)
          .then((res) => { row.student = res.data.student.firstName + ' ' +res.data.student.lastName;
            row.Phone  = res.data.parent.phone
           }); })
   progress.value = 0
      clearInterval(progressInterval)
    }
    const delRecord= async()=> {
      await api.delete(`/booklist/${delObj.value._id}`)
        .then(() => {
          loadData();
          delObj.value={};
          msgObj.value = { msg: "BookList Deleted Successfuly.", role: "danger", show: true, };
        });
    }
     onMounted(() => { loadData(); loadStudents(); })
</script>
